import { VAlert, VBtn, VCol, VDivider, VRow, VSpacer } from 'vuetify/lib'
import './Alert.scss'
import { h } from 'vue'

export const AlertBasico = VAlert.extend({
	name: 'Alert',
	extends: VAlert,
	props: {
		message: { default: '' },
		type: { default: 'warning' },
		dense: { default: false },
		tile: { default: false },
		transition: { default: '' },
		hasButton: { default: false },
		btnMessage: { default: '' },
		outlined: { default: false },
		elevation: { default: 0 }
	},

	computed: {
		computedProps(): Object {
			let props = {
				props: {
					...this.$props,
					icon: this.iconIs,
					color: this.colorIs
				}
			}

			return props
		},

		iconIs() {
			switch (this.type) {
				case 'error':
					return 'mdi-alert-circle-outline'
				case 'info':
					return 'mdi-information-outline'
				case 'success':
					return 'mdi-check-circle-outline'
				case 'warning':
					return 'mdi-alert-outline'
				default:
					return ''
			}
		},

		colorIs() {
			switch (this.type) {
				case 'error':
					return '#FFE9E6'
				case 'info':
					return '#FFF8E6'
				case 'success':
					return '#DBFFD9'
				case 'warning':
					return '#FFF8E6'
				default:
					return ''
			}
		}
	},

	methods: {
		renderAlert() {
			return h(
				VAlert,
				{
					class: 'pr-8',
					...this.computedProps,
					attrs: this.$attrs,
					scopedSlots: this.$scopedSlots
				},
				[
					this.message,
					this.hasButton ? this.renderButton() : null,
					this.message.length > 0 && (this.$scopedSlots.append || this.$scopedSlots.prepend) ? this.renderDivider() : null,
					this.$scopedSlots.append || this.$scopedSlots.prepend ? this.renderScopedSlots() : null
				]
			)
		},

		renderButton() {
			const listeners = Object.assign(this.listeners$, {
				click: this.emitClick
			})

			return [
				h(VSpacer),
				h(
					VBtn,
					{
						class: 'mt-2',
						props: {
							small: true,
							outlined: true,
							depressed: true,
							color: '#000000'
						},
						on: listeners
					},
					this.btnMessage
				)
			]
		},

		renderScopedSlots() {
			return h(VRow, [
				this.$scopedSlots.prepend && h(VCol, [h('div', this.$scopedSlots.prepend ? this.$scopedSlots.prepend(this.$props) : null)]),
				this.$scopedSlots.append && h(VCol, [h('div', this.$scopedSlots.append ? this.$scopedSlots.append(this.$props) : null)])
			])
		},

		renderDivider() {
			return h(VDivider, {
				class: 'my-4 error',
				style: 'opacity: 0.22'
			})
		},

		emitClick() {
			this.$emit('btnClick')
		}
	},

	render() {
		return h(
			'div',
			{
				class: 'd-flex flex-column'
			},
			[this.renderAlert()]
		)
	}
})

export default AlertBasico
